import { resolveEnvUrlWithWindow } from 'helpers/dynamic-url'

const DIALOG_SERVICE_URL = resolveEnvUrlWithWindow(
  import.meta.env.VITE_DIALOG_WEBSOCKET_URL
)

export const CHUNK_MS = 700
export const CALL_URL = `${DIALOG_SERVICE_URL}/api/v1/infinite_call/ws`
export const WAIT_FOR_LAST_AIVY_REPLICA_MS = 500

export enum MessageTypeEnum {
  outgoing = 'outgoing',
  incoming = 'incoming'
}
